export default function EditPayInfos(){
    return (
        <div>Editar inforções de pagamento</div>
    )
}